import { render, staticRenderFns } from "./TableName.vue?vue&type=template&id=5ff70077&scoped=true&"
import script from "./TableName.vue?vue&type=script&lang=js&"
export * from "./TableName.vue?vue&type=script&lang=js&"
import style0 from "./TableName.vue?vue&type=style&index=0&id=5ff70077&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ff70077",
  null
  
)

export default component.exports